import React from "react";
import { Pie } from "react-chartjs-2";

const SalesPieReport = ({
  data,
  options,
  formatSales,
  storess,
  range,
  chartRef,
  containerId,
}) => {
  const startDate = range?.tran_date?.$lte?.split("T")[0] || "";
  const endDate = range?.tran_date?.$gte?.split("T")[0] || "";

  return (
    <div ref={chartRef} id={containerId}>
      <div className="card pb-4">
        <Pie data={data} options={options} />
      </div>

      <div className="print-only-content">
        <h2>Report Details</h2>
        <div className="d-flex justify-content-between align-items-center print-only-content">
          <h3>Brand: Angels Pizza</h3>
          <h4 className="mx-auto"></h4>
          <h3>Store: {storess}</h3>
          <h3>Date: {`${startDate} ${endDate}`}</h3>
        </div>

        <div style={{ fontSize: "20px" }}>
          <table className="table text-center">
            <thead>
              <tr className="d-flex">
                <th>Month</th>
                <th className="ms-5">Sales</th>
              </tr>
            </thead>
            <tbody>
              {data.labels.map((label, index) => (
                <tr className="d-flex" key={`${containerId}-${label}`}>
                  <td>{label}</td>
                  <td>{formatSales(data.datasets[0].data[index])}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SalesPieReport;
